import React from 'react';
import { motion } from 'framer-motion';

const techStack = [
  {
    name: 'Microsoft Dynamics',
    logo: 'https://www.svgrepo.com/download/330338/dynamics365.svg'
  },
  {
    name: 'Salesforce',
    logo: 'https://www.vectorlogo.zone/logos/salesforce/salesforce-icon.svg'
  },
  {
    name: 'SAP',
    logo: 'https://www.vectorlogo.zone/logos/sap/sap-icon.svg'
  },
  {
    name: 'AWS',
    logo: 'https://www.vectorlogo.zone/logos/amazon_aws/amazon_aws-icon.svg'
  },
  {
    name: 'Azure',
    logo: 'https://www.vectorlogo.zone/logos/microsoft_azure/microsoft_azure-icon.svg'
  },
  {
    name: 'Contentful',
    logo: 'https://seeklogo.com/images/C/contentful-logo-C395C545BF-seeklogo.com.png'
  },
  {
    name: 'Strapi',
    logo: 'https://www.svgrepo.com/download/354399/strapi-icon.svg'
  },
  {
    name: 'Flutter',
    logo: 'https://www.vectorlogo.zone/logos/flutterio/flutterio-icon.svg'
  },
  {
    name: 'Next.js',
    logo: 'https://www.vectorlogo.zone/logos/nodejs/nodejs-icon.svg'
  },
  {
    name: 'React',
    logo: 'https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg'
  },
  {
    name: 'Node.js',
    logo: 'https://www.vectorlogo.zone/logos/nodejs/nodejs-icon.svg'
  },
  {
    name: 'Angular',
    logo: 'https://www.vectorlogo.zone/logos/angular/angular-icon.svg'
  },
  {
    name: 'Swift',
    logo: 'https://www.vectorlogo.zone/logos/swift/swift-icon.svg'
  },
  {
    name: 'Kotlin',
    logo: 'https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg'
  },
  {
    name: 'Python',
    logo: 'https://www.vectorlogo.zone/logos/python/python-icon.svg'
  },
  {
    name: 'JavaScript',
    logo: 'https://www.vectorlogo.zone/logos/javascript/javascript-icon.svg'
  }
];

// Duplicate the array to create a seamless loop
const duplicatedStack = [...techStack, ...techStack];

const TechStack = () => {
  return (
    <section className="py-16 md:py-20 overflow-hidden">
      <div className="container mx-auto px-4 mb-12">
        <h2 className="text-4xl font-semibold text-white text-center mb-4">
          Our Technology Expertise
        </h2>
        <p className="text-xl text-gray-400 text-center max-w-3xl mx-auto">
          We leverage cutting-edge technologies to deliver innovative solutions
        </p>
      </div>

      <div className="relative px-4 md:px-24">
        {/* Gradient Overlays */}
        <div className="absolute left-0 top-0 bottom-0 w-24 md:w-48 bg-gradient-to-r from-black via-black to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-24 md:w-48 bg-gradient-to-l from-black via-black to-transparent z-10" />

        {/* Scrolling Container */}
        <div className="overflow-hidden whitespace-nowrap">
          <motion.div
            className="inline-block"
            animate={{
              x: [0, -50 * techStack.length],
            }}
            transition={{
              x: {
                duration: 20, // Reduced from 50 to 20 seconds
                repeat: Infinity,
                ease: "linear",
              },
            }}
          >
            {duplicatedStack.map((tech, index) => (
              <div
                key={`${tech.name}-${index}`}
                className="inline-block mx-4 md:mx-12 w-20 md:w-32 h-32"
              >
                <div className="flex flex-col items-center justify-center h-full group">
                  <div className="relative w-12 md:w-16 h-12 md:h-16 mb-2">
                    <img
                      src={tech.logo}
                      alt={`${tech.name} logo`}
                      className="w-full h-full object-contain filter grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
                    />
                  </div>
                  <span className="text-sm text-gray-400 whitespace-normal text-center group-hover:text-accent transition-colors duration-300">
                    {tech.name}
                  </span>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TechStack;